<template>
  <div class="sub-page">
    <EventTeamSwiper />
    <BasketballMatchTabbar @setComponent="setComponent" />
    <component :is="component"></component>
  </div>
</template>

<script>
import EventTeamSwiper from '@comm/components/match/components/EventTeamSwiper.vue'
import BasketballMatchTabbar from './components/BasketballMatchTabbar.vue'
import BasketballInfo from './components/BasketballInfo.vue'
import BasketballSchedule from './components/BasketballSchedule.vue'
import BasketballRank from './components/BasketballRank.vue'
import BasketballDateCenter from './components/BasketballDateCenter.vue'
import MatchVolleyballSchedule from '@comm/components/MatchGame.vue'
import MatchVolleyballRank from '@comm/components/MatchRank.vue'
export default {
  name: 'BasketBallHome',
  props: {},
  components: {
    EventTeamSwiper,
    BasketballMatchTabbar,
    BasketballSchedule,
    BasketballInfo,
    BasketballRank,
    BasketballDateCenter,
    MatchVolleyballSchedule,
    MatchVolleyballRank,
  },
  data() {
    return {
      component: 'BasketballInfo',
    }
  },
  methods: {
    setComponent(component) {
      this.component = component
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/BasketBallHome.vue